import { pipe, tuple } from 'fp-ts/lib/function';
import * as A from 'fp-ts/lib/Array';
import * as E from 'fp-ts/lib/Either';


export const isData = (x: any[]): x is ({ id: number, text: string })[] => {
    return x.every(x => typeof(x.text) === 'string');
};

/**
 * Фильтрация текста
 * @param data 
 * @param text 
 */
export const filterText = <T extends Record<string, any>[]>(data: T, text: string) => 
    pipe(
        data,
        d => isData(d) ? E.right(d) : E.left([]),
        E.map(data => pipe(
            text,
            t => t === '' ? E.left('') : E.right(t),
            E.map(text => pipe(
                data,
                A.filter(t => pipe(
                    t,
                    t => t.text,
                    str => tuple(str.toUpperCase(), text.toUpperCase()),
                    ([str, substr]) => str.includes(substr),
                )),
            )),
            E.fold(
                () => {
                    return data;
                },
                (r) => {
                    return r;
                },
            )
        )),
        E.fold(
            (l) => l,
            (r) => r,
        ),
    );